module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_7042.d958a6a5.png";